// src/context/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../Services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
        
        // Set auth key in localStorage for API interceptor
        if (parsedUser.authKey) {
          localStorage.setItem('authKey', parsedUser.authKey);
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      // For demo purposes - replace with actual API call
      const demoUser = {
        id: 1,
        name: 'License Administrator',
        email: email,
        role: 'admin',
        department: 'License Management',
        // authKey: 'demo-auth-key-' + Date.now()
        authKey: 'z5NaBscERcF3hyl+TykKbBZGLveOWzcwlJFIEHAVjKQ=',
      };
      
      // Store user data with authKey
      localStorage.setItem('user', JSON.stringify(demoUser));
      localStorage.setItem('authKey', demoUser.authKey);
      setUser(demoUser);
      
      return { success: true, user: demoUser };
      
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: 'Login failed. Please try again.' };
    }
  };

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('authKey');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};